"use client";

import Button from "../SecondaryButton";
import Modal from "./Modal";
import CheckIcon from "@/assets/check-mark.svg";

interface IProps {
  close: () => void;
  isOpen: boolean;
  onStakeMoreClick: () => void;
}

const WithdrawSuccessfulModal = ({
  close,
  isOpen,
  onStakeMoreClick,
}: IProps) => {
  return (
    <Modal close={close} isOpen={isOpen} className="w-[90%] md:w-[660px]">
      <div className="flex flex-col gap-7 text-white text-center items-center">
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col gap-8 items-center">
            <CheckIcon className="w-20 h-20" />
            <span className="font-albert-sans text-2xl leading-7 uppercase">
              Withdrawal Successful
            </span>
          </div>
          <p className="text-base leading-5">
            Your SPON tokens have been successfully withdrawn to your wallet.
          </p>
        </div>

        <Button className="w-max" variant="light" onClick={onStakeMoreClick}>
          <div className="px-20">STAKE MORE</div>
        </Button>
      </div>
    </Modal>
  );
};

export default WithdrawSuccessfulModal;
